import {TAuthConfig} from "react-oauth2-code-pkce";
import {Helpers} from "./util/Helpers";
//

const authenticationBaseUrl = "https://signon-test.ibabs.eu";
// const authenticationBaseUrl = "https://signon.ibabs.eu";

// development
// const baseApiUrl = "https://localhost:53377/api/v0";
const baseApiUrl = `${process.env.REACT_APP_API_URL}/api/v0`;
// const authenticationRedirectUrl = 'https://localhost:3000/';
const authenticationRedirectUrl = window.location.origin + '/'

// // deploy
// const baseApiUrl = "https://ibabs-test-assistant-web-api.azurewebsites.net/api";
// const authenticationRedirectUrl = 'https://ibabs-test-assistant.pages.dev/';

console.log("baseApiUrl", baseApiUrl);
console.log("authenticationRedirectUrl", authenticationRedirectUrl);

let deviceKey = Helpers.getGetOrCreateKey("sU6yh6NfhSPu8ilH");

const authConfig: TAuthConfig = {
    clientId: '1488CC33-4559-447A-8610-B02CDBB0D747',
    authorizationEndpoint: `${authenticationBaseUrl}/OAuth/Authorize`,
    tokenEndpoint: `${authenticationBaseUrl}/OAuth/Token`,
    redirectUri: authenticationRedirectUrl ,
    extraAuthParameters: { "device_key": deviceKey},
    extraTokenParameters: { "device_key": deviceKey},
    onRefreshTokenExpire: (event) =>
        window.confirm('Tokens have expired. Refresh page to continue using the site?') && event.login(),
    // Example to redirect back to original path after login has completed
    preLogin: () => localStorage.setItem('preLoginPath', window.location.pathname),
    postLogin: () => window.location.replace(localStorage.getItem('preLoginPath') || ''),
    // storage: "session",
    decodeToken: true,
    // scope: 'User.read',
    autoLogin: false,
    refreshWithAuthHeader: true,
    refreshTokenExpiryStrategy: "renewable",
    tokenExpiresIn: 120,
    refreshTokenExpiresIn: 180,
    storage: "session",
}

export const Configuration = {
    // baseApiUrl: "https://localhost:7247/api",
    baseApiUrl: baseApiUrl,
    authenticationConfig: authConfig,
    authenticationDeviceKey: deviceKey,
}

